import Home from "./pages/home/Home"
import Signup from "./pages/signup/Signup"


function App() {
  return (
    <>
      <Home/>
      
    </>
    
    
  );
}

export default App;
